import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class TaxListDataService extends DataService<typeof Model.General.Logic.ViewModels.TaxSummary, Model.General.Logic.ViewModels.TaxSummary, TaxSummary> {
    protected map(entity: Model.General.Logic.ViewModels.TaxSummary): TaxSummary {
        return new TaxSummaryModel(entity);
    }

    public static make(context?: any): TaxListDataService {
        return new TaxListDataService(context, ctx=>ctx.TaxsSummaries);
    }
}

export class TaxSummaryModel extends EntityModel<Model.General.Logic.ViewModels.TaxSummary, TaxSummary> implements TaxSummary {

    @property<TaxSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<TaxSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;

    @property<TaxSummaryModel>(o => o.entity.percent, (o, value) => o.entity.percent = value)
    public percent: number;
}



// WEBPACK FOOTER //
// ./src/app/general/taxes/list/tax-list.data.ts